import {Injectable} from '@angular/core';
import {PhonePrefix} from 'src/app/domain/model/country/phone-prefix.model';
import countries from 'src/app/domain/service/api/country/countries.json';
import {CountryCode} from 'src/app/domain/service/api/country/country-code';

@Injectable({
  providedIn: 'root',
})
export default class CountriesResolverService {
  getPhonePrefixesArray(filterByPhonePrefix: Array<PhonePrefix> = []): PhonePrefix[] {
    const prefixes = Object.values(countries).map((country) => {
      if (!country.callingCode.length) {
        return undefined;
      }
      const prefix = country.callingCode.length? country.callingCode[0] : '';
      return {
        country: country.translations.spa.common,
        prefix
      };
    });

    let filteredPrefixes = [];
    if (filterByPhonePrefix.length) {
      filteredPrefixes = prefixes.filter((prefix) => filterByPhonePrefix.find((element) => element?.country === prefix?.country));
    }

    return filteredPrefixes.length
      ? filteredPrefixes.sort((a, b) => a.country.localeCompare(b.country)).filter(prefix => typeof prefix !== 'undefined')
      : prefixes.sort((a, b) => a.country.localeCompare(b.country)).filter(prefix => typeof prefix !== 'undefined');
  }

  getCountryCodes(): CountryCode[] {
    //TODO retrieve translation in function of the locale settings
    const countryCodes = Object.values(countries).map((country) => ({
      code: country.cca2,
      name: country.translations.spa.common
    }));

    return countryCodes.sort((a, b) => a.name.localeCompare(b.name));
  }
}
